import React from 'react';
import { connect } from 'react-redux';
import { Drawer, Button, Switch, List, Tag, Input, Icon, Tooltip } from 'antd';
import { compare } from 'natural-orderby';
import styled from 'styled-components';

import * as calendarTasksActions from "~/_domains/calendarTasks/actions";
import { request } from '../Instance';

var Search = Input.Search;

var formatDateShort = function(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    var day = String(d.getDate()).padStart(2, '0');
    var month = String(d.getMonth() + 1).padStart(2, '0');
    var year = d.getFullYear();
    return day + '/' + month + '/' + year;
};

var TAXATION_FILTERS = [
    { value: 'Simples Nacional', label: 'Simples Nacional', color: '#1890ff', bg: '#e6f7ff' },
    { value: 'Lucro Presumido', label: 'Lucro Presumido', color: '#722ed1', bg: '#f9f0ff' },
    { value: 'Lucro Real', label: 'Lucro Real', color: '#52c41a', bg: '#f6ffed' },
    { value: 'MEI', label: 'MEI', color: '#fa8c16', bg: '#fff7e6' },
    { value: 'Doméstica', label: 'Doméstica', color: '#eb2f96', bg: '#fff0f6' },
    { value: 'Profissional Liberal', label: 'Prof. Liberal', color: '#13c2c2', bg: '#e6fffb' },
    { value: 'Fiscal', label: 'Fiscal', color: '#faad14', bg: '#fffbe6' },
];

var VIEW_FILTERS = [
    { value: 'all', label: 'Todos' },
    { value: 'selected', label: 'Selecionados' },
    { value: 'unselected', label: 'Não selecionados' },
];

var HeaderSection = styled.div`
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;
`;

var SummaryRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

var SummaryLeft = styled.div`
    display: flex;
    align-items: baseline;
    gap: 4px;
`;

var SummaryCount = styled.span`
    font-size: 28px;
    font-weight: 700;
    color: #1890ff;
    line-height: 1;
`;

var SummaryText = styled.span`
    font-size: 13px;
    color: #8c8c8c;
`;

var SelectAllLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #595959;
`;

var ViewTabs = styled.div`
    display: inline-flex;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
`;

var FilterPills = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`;

var CustomerItem = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.12s;
    cursor: pointer;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f0f5ff;
    }
`;

var CustomerName = styled.div`
    flex: 1;
    font-size: 13px;
    color: #262626;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

var CustomerCod = styled.span`
    font-weight: 600;
    color: #595959;
    margin-right: 4px;
`;

var CustomerMeta = styled.div`
    font-size: 11px;
    color: #bfbfbf;
    margin-top: 2px;
    display: flex;
    align-items: center;
    gap: 4px;
`;

var ListContainer = styled.div`
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    overflow: hidden;
`;

var FooterBar = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 24px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    z-index: 10;
`;

var FooterInfo = styled.div`
    font-size: 13px;
    color: #8c8c8c;
    display: flex;
    align-items: center;
    gap: 6px;
`;


class Customers extends React.Component {

    state = {
        search: '',
        filter: null,
        viewFilter: 'all',
        loading: true,
        customersChecked: [],
        customerDetails: {},
        isModified: false
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.task !== null && (this.props.task === null || nextProps.task.id !== this.props.task.id)){

            if (this.state.isModified) {
                this.setState({ isModified: false });
            }

            this.setState({ loading: true });

            request('get', '/task/' + nextProps.task.id + '/customers', {}, false)
            .then(function(response) {
                var data = response.data;
                // Support both old format (array of ids) and new format (object with customer_ids + details)
                if (data && data.customer_ids) {
                    this.setState({
                        customersChecked: data.customer_ids,
                        customerDetails: data.details || {},
                        loading: false
                    });
                } else {
                    this.setState({
                        customersChecked: data,
                        customerDetails: {},
                        loading: false
                    });
                }
            }.bind(this))
        }
    }

    filterCustomers = (search, filter, viewFilter) => {
        var customers = this.props.customers;
        var customersChecked = this.state.customersChecked;

        var filtered = (customers !== null) ? customers.filter(function(str) {
            var taxation = true;
            if((str.type_taxation !== null && filter !== null && str.type_taxation.toLowerCase().indexOf(filter.toLowerCase()) === -1)
                || str.type_taxation === null && filter !== null){
                taxation = false;
            }

            var matchSearch = false;
            if(str.name.toLowerCase().indexOf(search.toLowerCase()) >= 0 && taxation){
                matchSearch = true;
            }
            if(str.email !== null && str.email.toLowerCase().indexOf(search.toLowerCase()) >= 0 && taxation){
                matchSearch = true;
            }
            if(str.identification_number !== null && str.identification_number.toString().toLowerCase().indexOf(search.toLowerCase()) >= 0 && taxation){
                matchSearch = true;
            }
            if(str.cnpj_formated !== null && str.cnpj_formated.toLowerCase().indexOf(search.toLowerCase()) >= 0 && taxation){
                matchSearch = true;
            }
            if(str.cod !== null && str.cod.toLowerCase().indexOf(search.toLowerCase()) >= 0 && taxation){
                matchSearch = true;
            }

            if (!matchSearch) return false;

            // View filter
            if (viewFilter === 'selected') {
                return customersChecked.indexOf(str.id) !== -1;
            }
            if (viewFilter === 'unselected') {
                return customersChecked.indexOf(str.id) === -1;
            }
            return true;
        }) : [];

        filtered = filtered.sort(function(a, b) { return compare()(a.cod, b.cod); });

        return filtered;
    }

    handleCheckAll = (value) => {
        var filteredCustomers = this.filterCustomers(this.state.search, this.state.filter, this.state.viewFilter);
        var pendent = filteredCustomers.filter(function(row) {
            return this.state.customersChecked.indexOf(row.id) === -1;
        }.bind(this));

        var mapPendent = pendent.map(function(row) { return row.id; });

        this.props.addCustomers(this.props.task.id, {
            checked: value,
            customers: value ? mapPendent : this.state.customersChecked
        })
        .then(function() {
            this.goToNextOnboardingStep();
            this.setState({
                customersChecked: value ? [
                    ...this.state.customersChecked, ...mapPendent
                ] : [],
                loading: false,
                isModified: true
            });
        }.bind(this));
    }

    goToNextOnboardingStep = () => {
        // placeholder for onboarding
    }

    closeDrawer = () => {
        this.props.onClose();
        if (this.state.isModified) {
            this.props.loadAllDepartmentsCalendarTasks();
        }
    }

    handleToggleCustomer = (item, value) => {
        var customersChecked = this.state.customersChecked;
        this.setState({
            customersChecked: value ? [
                ...customersChecked, item.id
            ] : customersChecked.filter(function(row) { return row !== item.id; })
        });
        this.props.addCustomer(this.props.task.id, { customer_id: item.id, checked: value }).then(function() {
            this.goToNextOnboardingStep();
            this.setState({ isModified: true });
        }.bind(this));
    }

    render() {
        var task = this.props.task;
        var customers = this.props.customers;
        var search = this.state.search;
        var loading = this.state.loading;
        var customersChecked = this.state.customersChecked;
        var filter = this.state.filter;
        var viewFilter = this.state.viewFilter;
        var self = this;

        var filteredCustomers = this.filterCustomers(search, filter, viewFilter);
        var totalCustomers = customers ? customers.length : 0;
        var selectedCount = customersChecked.length;

        // Count per taxation type
        var taxationCounts = {};
        TAXATION_FILTERS.forEach(function(t) { taxationCounts[t.value] = 0; });
        if (customers) {
            customers.forEach(function(c) {
                if (c.type_taxation && taxationCounts[c.type_taxation] !== undefined) {
                    taxationCounts[c.type_taxation]++;
                }
            });
        }

        var pillStyle = function(f, isActive) {
            return {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '4px 10px',
                borderRadius: 16,
                fontSize: 11,
                fontWeight: isActive ? 600 : 400,
                cursor: 'pointer',
                transition: 'all 0.15s',
                border: '1px solid ' + (isActive ? f.color : '#e8e8e8'),
                background: isActive ? f.bg : '#fff',
                color: isActive ? f.color : '#8c8c8c',
            };
        };

        var viewTabStyle = function(value) {
            var isActive = viewFilter === value;
            return {
                padding: '6px 16px',
                fontSize: 12,
                fontWeight: isActive ? 600 : 400,
                cursor: 'pointer',
                background: isActive ? '#1890ff' : '#fff',
                color: isActive ? '#fff' : '#595959',
                border: 'none',
                outline: 'none',
                transition: 'all 0.15s',
            };
        };

        var percentSelected = totalCustomers > 0 ? Math.round((selectedCount / totalCustomers) * 100) : 0;

        return (
            <div>
                {task && (
                <Drawer
                    title={task.name + ' / Clientes'}
                    width={720}
                    placement="right"
                    onClose={this.closeDrawer}
                    maskClosable={true}
                    visible={this.props.visible}
                    zIndex={1020}
                    bodyStyle={{ padding: '20px 24px 68px', background: '#fafafa' }}
                >

                <HeaderSection>
                    <SummaryRow>
                        <SummaryLeft>
                            <SummaryCount>{selectedCount}</SummaryCount>
                            <SummaryText>de {totalCustomers} clientes selecionados</SummaryText>
                        </SummaryLeft>
                        <SelectAllLabel>
                            <Switch
                                size="small"
                                checked={filteredCustomers.length > 0 && filteredCustomers.every(function(c) { return customersChecked.indexOf(c.id) !== -1; })}
                                onChange={function(val) { self.handleCheckAll(val); }}
                            />
                            Selecionar todos
                        </SelectAllLabel>
                    </SummaryRow>

                    <div style={{ height: 4, background: '#f0f0f0', borderRadius: 2, marginBottom: 16, overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: percentSelected + '%', background: '#1890ff', borderRadius: 2, transition: 'width 0.3s' }} />
                    </div>

                    <Search
                        placeholder="Pesquisar por nome, código ou CNPJ..."
                        onChange={function(e) { self.setState({ search: e.target.value }); }}
                        style={{ marginBottom: 12 }}
                        size="large"
                        allowClear
                    />

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
                        <ViewTabs>
                            {VIEW_FILTERS.map(function(v) {
                                return (
                                    <div
                                        key={v.value}
                                        style={viewTabStyle(v.value)}
                                        onClick={function() { self.setState({ viewFilter: v.value }); }}
                                    >
                                        {v.label}
                                        {v.value === 'selected' ? ' (' + selectedCount + ')' : ''}
                                        {v.value === 'unselected' ? ' (' + (totalCustomers - selectedCount) + ')' : ''}
                                    </div>
                                );
                            })}
                        </ViewTabs>
                    </div>
                </HeaderSection>

                <FilterPills>
                    {TAXATION_FILTERS.map(function(f) {
                        if (taxationCounts[f.value] === 0) return null;
                        var isActive = filter === f.value;
                        return (
                            <span
                                key={f.value}
                                style={pillStyle(f, isActive)}
                                onClick={function() { self.setState({ filter: isActive ? null : f.value }); }}
                            >
                                <span style={{
                                    width: 6, height: 6, borderRadius: '50%',
                                    background: f.color, flexShrink: 0
                                }}></span>
                                {f.label}
                                <span style={{ fontWeight: 600, opacity: 0.7 }}>{taxationCounts[f.value]}</span>
                            </span>
                        );
                    })}
                </FilterPills>

                <ListContainer>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
                            <Icon type="loading" style={{ fontSize: 24, color: '#1890ff' }} />
                        </div>
                    ) : filteredCustomers.length === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 48, color: '#bfbfbf' }}>
                            <Icon type="inbox" style={{ fontSize: 40, marginBottom: 10 }} />
                            <span style={{ fontSize: 14 }}>Nenhum cliente encontrado</span>
                        </div>
                    ) : (
                        filteredCustomers.map(function(item) {
                            var isChecked = customersChecked.indexOf(item.id) !== -1;
                            var taxFilter = TAXATION_FILTERS.find(function(t) { return t.value === item.type_taxation; });
                            var detail = self.state.customerDetails[item.id];

                            return (
                                <CustomerItem
                                    key={item.id}
                                    onClick={function() { self.handleToggleCustomer(item, !isChecked); }}
                                    style={isChecked ? { background: '#f0f5ff' } : {}}
                                >
                                    <Switch size="small" checked={isChecked} />
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <CustomerName>
                                            {item.cod && <CustomerCod>{item.cod} -</CustomerCod>}
                                            {' '}{item.name}
                                        </CustomerName>
                                        {isChecked && detail && (detail.created_by_name || detail.created_at) && (
                                            <Tooltip title={'Adicionado por ' + (detail.created_by_name || 'Usuário') + ' em ' + formatDateShort(detail.created_at)}>
                                                <CustomerMeta>
                                                    <Icon type="user" style={{ fontSize: 10 }} />
                                                    {detail.created_by_name || 'Usuário'}
                                                    <span style={{ margin: '0 2px' }}>·</span>
                                                    <Icon type="clock-circle" style={{ fontSize: 10 }} />
                                                    {formatDateShort(detail.created_at)}
                                                </CustomerMeta>
                                            </Tooltip>
                                        )}
                                    </div>
                                    {item.type_taxation && (
                                        <Tag
                                            color={taxFilter ? taxFilter.color : 'purple'}
                                            style={{ margin: 0, fontSize: 11, flexShrink: 0 }}
                                        >
                                            {item.type_taxation}
                                        </Tag>
                                    )}
                                </CustomerItem>
                            );
                        })
                    )}
                </ListContainer>

                <FooterBar>
                    <FooterInfo>
                        <Icon type="team" style={{ fontSize: 14 }} />
                        {filteredCustomers.length} cliente{filteredCustomers.length !== 1 ? 's' : ''} exibido{filteredCustomers.length !== 1 ? 's' : ''}
                    </FooterInfo>
                    <Button onClick={this.closeDrawer} style={{ height: 40, fontSize: 14, padding: '0 24px', borderRadius: 8 }}>
                        Fechar
                    </Button>
                </FooterBar>

                </Drawer>
                )}
            </div>
        );
    }
}

var mapStateToProps = function(state) {
    return {
        customers: state.customers.list.filter(function(row) { return row.enabled && row.inactived_at === null && row.is_customer; }),
        user: state.user
    };
};

var mapDispatchProps = function(dispatch) {
    return {
        addCustomer: function(id, data) {
            return dispatch({
                type: 'TASK_ADD_CUSTOMER',
                payload: {
                    request: {
                        method: 'POST',
                        url: '/task/' + id + '/add',
                        data: data
                    }
                }
            });
        },
        addCustomers: function(id, data) {
            return dispatch({
                type: 'TASK_ADD_CUSTOMERS',
                payload: {
                    request: {
                        method: 'POST',
                        url: '/task/' + id + '/add/all',
                        data: data
                    }
                }
            });
        },
        loadAllDepartmentsCalendarTasks: function() {
            return dispatch(calendarTasksActions.loadAllDepartmentsCalendarTasks());
        },
    };
};

export default connect(mapStateToProps, mapDispatchProps)(Customers);
